import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { StartStore } from './start.store';
import { StartComponent } from './start.component';

@inject('appStore', 'routerStore')
@observer
export class StartProvider extends Component {
    store;

    constructor(props) {
        super(props);
        const { appStore, match } = props;

        appStore.setURLProps(match);

        appStore.reset(() => {
        });

        this.store = new StartStore({
            appStore
        });

        this.store.initializeContent();
    }

    render() {
        return <Provider store={this.store}>
            <StartComponent key='startpage' />
        </Provider>;
    }
}
